import React from 'react';
import PropTypes from 'prop-types';

const whenNotToUpdate = (prev, next) => {  // eslint-disable-line
  return false;
  // return prev.step === next.step;
};

const BodyPane = React.memo(props => {
  const { sections, transitions } = props;

  return (
    <div className="scan-body">
      {transitions.map(({ item, props, key }) => {
        const Page = sections[item];
        return <Page key={key} style={props} />;
      })}
    </div>
  );
}, whenNotToUpdate);

BodyPane.propTypes = {
  sections: PropTypes.array,
  transitions: PropTypes.array,
};

export default BodyPane;
